<template>
  <button
    class="theme-toggle"
    :class="{ 'theme-toggle--workspace': $route.path !== '/' && $route.path !== '/login' }"
    type="button"
    :aria-label="toggleLabel"
    :title="toggleLabel"
    @click="toggleTheme">
    <i :class="themeIcon" aria-hidden="true"></i>
  </button>
</template>

<script>
import { t } from "@/i18n";
import { applyTheme, getActiveTheme, setTheme } from '@/utils/theme';

export default {
  name: 'ThemeToggle',
  data() {
    return {
      activeTheme: getActiveTheme(),
    };
  },
  computed: {
    isDark() {
      return this.activeTheme === 'dark';
    },
    themeIcon() {
      return this.isDark ? 'el-icon-sunny' : 'el-icon-moon';
    },
    toggleLabel() {
      return this.isDark ? t("切换到浅色模式") : t("切换到深色模式");
    },
  },
  created() {
    this.handleThemeChange = (event) => {
      this.activeTheme = event.detail && event.detail.theme
        ? event.detail.theme
        : getActiveTheme();
    };
    window.addEventListener('theme-change', this.handleThemeChange);
    window.addEventListener('storage', this.handleStorageChange);
  },
  beforeDestroy() {
    window.removeEventListener('theme-change', this.handleThemeChange);
    window.removeEventListener('storage', this.handleStorageChange);
  },
  methods: {
    toggleTheme() {
      this.activeTheme = setTheme(this.isDark ? 'light' : 'dark');
    },
    handleStorageChange(event) {
      if (event.key === 'ilean-theme') {
        this.activeTheme = applyTheme(getActiveTheme());
      }
    },
  },
};
</script>

<style scoped>
.theme-toggle {
  position: fixed;
  top: 12px;
  right: 18px;
  z-index: 3001;
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid var(--border-color);
  border-radius: 10px;
  background: var(--surface-color);
  color: var(--text-regular);
  box-shadow: 0 4px 14px var(--shadow-color);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  transition:
    color 0.2s ease,
    border-color 0.2s ease,
    background-color 0.2s ease,
    transform 0.2s ease;
}

.theme-toggle:hover {
  color: var(--primary-color);
  border-color: var(--primary-color);
  background: var(--surface-hover);
  transform: translateY(-1px);
}

.theme-toggle:focus-visible {
  outline: 2px solid var(--primary-color);
  outline-offset: 2px;
}

.theme-toggle--workspace {
  top: 18px;
  right: 22px;
  z-index: 30;
  width: 40px;
  height: 40px;
  border-color: var(--border-light);
  border-radius: 11px;
  box-shadow: none;
}

@media (max-width: 900px) {
  .theme-toggle--workspace {
    top: 12px;
    right: 14px;
  }
}

@media (max-width: 768px) {
  .theme-toggle {
    right: 12px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .theme-toggle {
    transition: none;
  }
}
</style>
